export default function columns() {
  $('.wp-block-columns').each(function () {
    const $cols = $(this);
    /**
     * Count number of columns
     */
    const cols = $cols.find('> .wp-block-column').length;
    $cols.find('> .wp-block-column').each(function () {
      // Use classes instead of harcoded percentages
      const width = Math.round(parseFloat($(this).css('flex-basis')));
      if (width === 50) {
        $(this).addClass('col-md-6');
      } else if (width === 33) {
        $(this).addClass('col-md-6');
        $(this).addClass('col-xl-4');
      } else if (width === 66 || width === 67) {
        $(this).addClass('col-md-6');
        $(this).addClass('col-xl-8');
      } else {
        $(this).addClass(`col-md-${parseInt(12 / cols)}`);
      }

      $(this).removeAttr('style');
    });

    /**
     * Columns with media, gallery or video
     */
    const media =
      'video, .wp-block-gallery, .wp-block-media-text__media, .wp-block-image';
    if ($cols.find(media).length) {
      $cols.find('.wp-block-column').each(function () {
        if ($(this).find(media).length) {
          $(this).addClass('col-media');
        } else {
          $(this).addClass('col-text');
        }
      });
    }
  });
}
